import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddConfigurationServices {
  constructor(private http:HttpClient) { }

  addPackageConfig(data:any){
    return this.http.post(environment.apiUrl + "packageConfig/addNew" , data)
  }
  addRange(data:any){
    return this.http.post(environment.apiUrl + "range/addNew", data)
  }
  addCoupan(data:any){
    return this.http.post(environment.apiUrl + "coupon/addNew", data)
  }
  addQrConfig(data:any){
    return this.http.post(environment.apiUrl + "qrCodeConfig/addNew" , data);
  }
  addPackerMoverConfig(data:any){
    return this.http.post(environment.apiUrl + "packerMoverConfig/addNew", data);
  }
  addApplicationConfig(data:any){
    return this.http.post(environment.apiUrl + "appConfig/addNew", data)
  }
}